/**
 * import react
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui
 */
import Button from '@material-ui/core/Button';

/**
 * import component
 */
import DeviceTsdbInfoDlg from './device-tsdb-info-dlg';

const DeviceExtendedTsdbInfo = (props) => {
  const [infoDlg, setInfoDlg] = useState({open: false});
  const list = [
    {txt: 'Heartbeat', db: 'devices', measurement: 'heartbeat', searchKey: 'device_id'},
    {txt: 'Actions', db: 'actions', measurement: 'action', searchKey: 'device_id'},
    {txt: 'Config', db: 'configurations', measurement: 'config', searchKey: 'config_name'},
    {txt: 'Configmap', db: 'configurations', measurement: 'configmap', searchKey: 'device_id'},
    {txt: 'Flavor', db: 'configurations', measurement: 'flavor', searchKey: 'flavor_name'},
    {txt: 'Lconf', db: 'localconfs', measurement: 'lconf', searchKey: 'device_id'}
  ];

  const handleClose = () => {
    setInfoDlg(() => ({open: false}));
  };

  const handler = ({txt, db, measurement, searchKey}) => {
    return () => {
      var searchValue

      if (searchKey === 'config_name') {
        searchValue = props.device.config_name
      } else if (searchKey === 'flavor_name') {
        searchValue = props.device.flavor_name
      } else {
        searchValue = props.device.id
      }

      setInfoDlg(() => ({open: true, txt, db, measurement, deviceId : props.device.id, searchKey, searchValue, time: '7d', handleClose}));
    };
  };

  return (
    <>
      <h4>Raw DB Info</h4>
      {
        list.map((item) => {
          const {txt} = item;
          return (
            <Button key={txt} style={{textTransform: 'none'}} size='small' onClick={handler(item)}>{txt}</Button>
          );
        })
      }
      {infoDlg.open ? <DeviceTsdbInfoDlg {...infoDlg}/> : null}
    </>
  );
};

export default DeviceExtendedTsdbInfo;

DeviceExtendedTsdbInfo.propTypes = {
  deviceId: PropTypes.string.isRequired
};
